// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ecf7405a","732":"7501f243","977":"6fb75e90"}[chunkId] + ".chunk.js";
};